"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = require("../utils/get");
var formatter_1 = require("../utils/formatter");
// This function replaces placeholders enclosed in curley braces with the actual value. For example:
// "http://www.clientwebsitesite.com/fundexplorer/{isin}" -> "http://www.clientwebsitesite.com/fundexplorer/GB1234567890"
exports.replacePlaceholders = function (replacePlaceholdersOptions) {
    var values = replacePlaceholdersOptions.values, valueKey = replacePlaceholdersOptions.valueKey, text = replacePlaceholdersOptions.text, appParamsHelper = replacePlaceholdersOptions.appParamsHelper, format = replacePlaceholdersOptions.format;
    if (text) {
        var _a = format || {}, type_1 = _a.type, locale_1 = _a.locale, currency_1 = _a.currency, options_1 = _a.options;
        var parsedText = text.replace(/({)[^{]+(})/g, function (match) {
            var key = match.replace('{', '').replace('}', '');
            if (appParamsHelper && appParamsHelper.rawAppParams && key.substring(0, 4).toLowerCase() === 'app:') {
                return appParamsHelper.rawAppParams[key.substring(4, key.length)];
            }
            var value = get_1.get(values, "" + key + (valueKey ? valueKey : ''), '');
            return format
                ? formatter_1.default(type_1, locale_1, currency_1, options_1, value)
                : value;
        });
        return parsedText;
    }
};
//# sourceMappingURL=replacePlaceholders.js.map